/**
 * 
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */
 import ServiceConstant from "@/app/core/ServiceConstant"
 import MainService from "@/app/services/MainService";
 
 export default class ReceptionService extends MainService {
 
     static listAllPagination(params){
         return this.postSEC(ServiceConstant.PATIENT_MNGT_LIST_PAGED_RECEPTION, params);
     }
     
     static add(params){
         return this.postSEC(ServiceConstant.PATIENT_ADD, params)
     }
     
     static get(params){
         return this.postSEC(ServiceConstant.PATIENT_GET, params)
     }
     
     static update(params){
         return this.postSEC(ServiceConstant.PATIENT_UPDATE, params)
     }
     
     static delete(params){
         return this.postSEC(ServiceConstant.PATIENT_DELETE, params)
     }
     
     static updateStatus(params){
         return this.postSEC(ServiceConstant.PATIENT_UPDATE_STATUS, params)
     }
 
     static getBasicInformation(idPatient){
         return this.postSEC(ServiceConstant.PATIENT_GET_BASIC_INFORMATION, {idPatient: idPatient});
     }
 
 }